const { produce } = require("immer");

const initState = {
  projectUid: null,
  fullscreen: false,
  openedMenu: false,
  disconnectedProjects: [],

  userUids: [],
  nav: {},

  // LoadBundle
  selectedLicenceUid: null,
  selectedModuleKey: null,
  appBars: {},
  licences: [],
  modules: {},
  modulesBundle: {},
  loadedScripts: [],

  hideWorkspaceMenu: false,
  workspaceMenuFilter: {
    tasks: true,
    storage: true,
    tools: true
  },

  files: {},
  folders: [],
  tasks: {},
  folderSize: {},
  view: null,
  opened: false,
  closing: false,
};

/** Top level Reducer **/

var index = 0;

function project_reducer(state = initState, action) {

  switch (action.type) {

    case "OPEN_PROJECT": return produce(state, draft => {
      if (state.projectUid !== action.uid) {
        Object.assign(draft, initState)
        draft.projectUid = action.uid
        draft.licences = action.licences || []

      } else {
        if (action.licences && (
          action.licences.length !== state.licences.length ||
          action.licences.some(uid => !state.licences.includes(uid))
        )) {
          draft.licences = action.licences
        }
      }
      Object.assign(draft, action.project)
      draft.modulesBundle = state.modulesBundle
      draft.fullscreen = state.fullscreen
      draft.openedMenu = state.openedMenu
      draft.opened = true
      draft.closing = false
      draft.disconnectedProjects = draft.disconnectedProjects.filter(uid => uid !== action.uid)
    });

    case "OPEN_WORKSPACE_MENU": return produce(state, draft => {
      draft.openedMenu = action.open
    });

    case "HIDE_WORKSPACEMENU": return produce(state, draft => {
      draft.hideWorkspaceMenu = action.hide
    });

    // FILES
    case "ADD_FILE": return produce(state, draft => {
      Object.assign(draft.files, action.file);
    });

    case "APP_SETTINGS": {
      return produce(state, draft => {
        const { modules } = action.settings
        draft.modules[action.licenceUid] = modules.list
        if (modules.appBar) {
          draft.appBars[action.licenceUid] = modules.appBar
        }
        draft.selectedModuleKey = modules.list[0].key
      })
    }

    case "LOAD_BUNDLE": {
      const { licenceUid, moduleKey } = action;
      return produce(state, draft => {
        if (!(licenceUid in draft.modulesBundle)) draft.modulesBundle[licenceUid] = {};
        draft.modulesBundle[licenceUid][moduleKey] = Date.now();
      });
    }

    case "LOAD_SCRIPT":
      return produce(state, draft => {
        if (!draft.loadedScripts.includes(action.id)) {
          draft.loadedScripts.push(action.id);
        }
      });

    case "LOADBUNDLE_RETRY":
      return produce(state, draft => {
        draft.loadedScripts = [];
        draft.selectedModuleKey = null;
      });

    case "ADD_FOLDER": return produce(state, draft => {
      draft.folders = [...draft.folders, action.folder];
    });

    case "STORAGE_SIZE_UPDATE": return produce(state, draft => {
      draft.folderSize = action.folderSize
    });

    // TASKS
    case "ADD_TASK":
      var startKey = `tasks#${action.task.type}#${action.task.uid}:metadata:`
      var task = Object.keys(action.task).reduce((result, key) => {
        return {
          ...result,
          [startKey + key]: action.task[key]
        }
      }, {})
      return produce(state, draft => Object.assign(draft.tasks, task));

    case "TASK_KEY_UPDATE": return produce(state, draft => {
      draft.tasks = {
        ...draft.tasks,
        [action.key]: action.value
      }
    });

    case "CHANGE_BLOCK_COLOR":
      if (index < state.blockStyleList.length - 1) {
        index++
      } else index = 0

      return produce(state, draft => {
        draft.blockStyle = state.blockStyleList[index];
      });

    case "SET_FULLSCREEN": return produce(state, draft => {
      draft.fullscreen = action.fullscreen;
    });

    case "WORKSPACEMENU_FILTER": return produce(state, draft => {
      draft.workspaceMenuFilter = action.workspaceMenuFilter;
    });

    case "SELECT_LICENCE": {
      let moduleKey = state.nav[action.licenceUid];
      return produce(state, draft => {
        draft.selectedLicenceUid = action.licenceUid;
        if (moduleKey) {
          draft.selectedModuleKey = moduleKey;
        }
      });
    }

    case "SWITCH_LICENCE": {
      return produce(state, draft => {
        draft.selectedLicenceUid = action.licenceUid
        let modules = draft.modules[action.licenceUid] || []
        draft.selectedModuleKey = modules && modules.length ? modules[0].key : null
      });
    }

    case "SELECT_MODULE": {
      let licenceUid = state.selectedLicenceUid;
      return produce(state, draft => {
        draft.selectedModuleKey = action.moduleKey;
        Object.assign(draft.nav, {
          [licenceUid]: action.moduleKey
        });
      });
    }

    case "CLOSE_PROJECT":
      if (!action.uid || state.projectUid === action.uid) return initState
      else return produce(state, draft => {
        if (!draft.disconnectedProjects.includes(action.uid)) {
          draft.disconnectedProjects.push(action.uid)
        }
      })

    case "ADD_WORKSPACE": {
      return produce(state, draft => {
        if (action.uid !== state.projectUid) {
          draft.projectUid = action.uid;
          draft.disconnectedProjects = draft.disconnectedProjects.filter(uid => uid !== action.uid)
        }
      });
    }

    case "SOCKET_DISCONNECTED":
    case "SOCKET_ERROR":
      return produce(state, draft => {
        draft.opened = false
        if (state.projectUid && !state.disconnectedProjects.includes(state.projectUid)) {
          draft.disconnectedProjects.push(state.projectUid)
        }
      })

    case "PROJECT_RECONNECT":
      return produce(state, draft => {
        if (state.projectUid === action.projectUid) {
          draft.opened = true
          draft.closing = false
        }
        if (state.disconnectedProjects.includes(action.projectUid)) {
          draft.disconnectedProjects = draft.disconnectedProjects.filter(uid => {
            return uid !== action.projectUid
          })
        }
      })

    case "WORKSPACE_CLOSING":
      return produce(state, draft => {
        const uid = action.uid || draft.projectUid
        if (uid) {
          if (draft.projectUid === uid) {
            draft.closing = true
          } else if (!draft.disconnectedProjects.includes(uid)) {
            draft.disconnectedProjects.push(uid)
          }
        }
      })

    default:
      return state
  }
}

module.exports = project_reducer
